"use strict";
(function (global) {
    class CyberPakietWebVulnerabilitiesHierarchicalController {
        constructor() {
            const controller = this;
            ApiConnect.get('/member/api/cyber-pakiet/web/applications/by-url').then(response => {
                let urls = $("#accordion");
                response.data.forEach(url => {
                    let count;
                    if (url.count === 1) {
                        count = '1 podatność';
                    } else {
                        count = url.count + ' podatności';
                    }
                    const head = document.createElement("h3");
                    const displayedUrl = url.url === 'unknown' ? 'Nieznany URL' : url.url;
                    head.innerHTML = displayedUrl + ' (' + count + ')';
                    urls.append(head);
                    const body = document.createElement("div");
                    body.innerHTML = "<div data-url='" + url.url + "' class='id'></div>";
                    urls.append(body);
                });
                urls.accordion({
                    heightStyle: "content",
                    collapsible: true,
                    active: false,
                    beforeActivate: function (event, ui) {
                        if (ui.newPanel[0].children[0].className === 'id') {
                            const url = ui.newPanel[0].children[0].dataset['url'];
                            const block = $("[data-url='" + url + "']");
                            block.html("");
                            block.removeClass('id');
                            block.addClass('spinner');
                            ApiConnect.get('/member/api/cyber-pakiet/web/applications/by-severity?url=' + url).then(response => {
                                block.removeClass('spinner');
                                controller.showSeverityList(response);
                            }).catch((errorThrown) => {
                                if (errorThrown !== 'redirect') {
                                    ApiNotification.notify({
                                        type: 'error',
                                        _message: 'Wystąpił błąd podczas wczytywania danych'
                                    });
                                }
                            });
                        }
                    }
                });
            }).catch((errorThrown) => {
                if (errorThrown !== 'redirect') {
                    ApiNotification.notify({type: 'error', _message: 'Wystąpił błąd podczas wczytywania danych'});
                }
            });
        }

        showSeverityList(response) {
            const controller = this;
            let container = $("[data-url='" + response.url + "']");
            response.data.forEach(severity => {
                let count;
                if (severity.count === 1) {
                    count = '1 podatność';
                } else {
                    count = severity.count + ' podatności';
                }
                const head = document.createElement("h3");

                let displayedSeverity = 'Nieznana krytyczność';

                switch (severity.severity) {
                    case 'critical':
                        displayedSeverity = 'Krytyczna';
                        break;
                    case 'high':
                        displayedSeverity = 'Wysoka';
                        break;
                    case 'medium':
                        displayedSeverity = 'Średnia';
                        break;
                    case 'low':
                        displayedSeverity = 'Niska';
                        break;
                    case 'log':
                        displayedSeverity = 'Log';
                        break;
                    case 'info':
                        displayedSeverity = 'Informacyjna';
                        break;
                }

                head.innerHTML = displayedSeverity + ' (' + count + ')';
                container.append(head);
                const body = document.createElement("div");
                body.innerHTML = "<div data-url='" + response.url + "' data-severity='" + severity.severity + "' class='id'></div>";
                container.append(body);
            });
            container.accordion({
                heightStyle: "content",
                collapsible: true,
                active: false,
                beforeActivate: function (event, ui) {
                    if (ui.newPanel[0].children[0].className === 'id') {
                        const url = ui.newPanel[0].children[0].dataset['url'];
                        const severity = ui.newPanel[0].children[0].dataset['severity'];
                        const block = $("[data-url='" + url + "'][data-severity='" + severity + "']");
                        block.html("");
                        block.removeClass('id');
                        block.addClass('spinner');
                        ApiConnect.get('/member/api/cyber-pakiet/web/applications/for-severity/' + severity + '?url=' + url).then(data => {
                            controller.listVulnerabilities(data);
                        }).catch((errorThrown) => {
                            if (errorThrown !== 'redirect') {
                                ApiNotification.notify({
                                    type: 'error',
                                    _message: 'Wystąpił błąd podczas wczytywania danych'
                                });
                            }
                        });
                    }
                }
            });
        }

        listVulnerabilities(response) {
            const list = document.createElement("div");
            list.setAttribute('class', 'vulnerabilities');
            response.data.forEach(vulnerability => {
                const el = document.createElement("a");
                el.setAttribute('href', '/member/cyber-pakiet/web/vulnerabilities/' + vulnerability.id);
                el.innerText = vulnerability.name + ' (lokalizacja: ' + (vulnerability.location || 'b.d.') + ')';
                list.append(el);
            });
            const selector = "[data-url='" + response.url + "'][data-severity='" + response.severity + "']";
            $(selector).removeClass('spinner');
            $(selector).append(list);
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.CyberPakietWebVulnerabilitiesHierarchicalController = CyberPakietWebVulnerabilitiesHierarchicalController || {};

})(window);
